import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "./local-storage.service";

@Injectable({
  providedIn: "root",
})
export class RouterService {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {}

  async navigateTo(route: string): Promise<void> {
    const currentPage = await this.localStorageService.getItem("currentPage");
    if (route == "home") {
      await this.localStorageService.setItem("previousPages", []);
    } else {
      let previousPages =
        (await this.localStorageService.getItem("previousPages")) || [];
      if (currentPage) {
        previousPages.push(currentPage);
      }
      await this.localStorageService.setItem("previousPages", previousPages);
    }
    await this.localStorageService.setItem("currentPage", route);
    console.log(`navigateTo: ${route}`);

    // Handle routes with parameters by splitting into segments
    if (route.startsWith("/")) {
      // Absolute path - use navigateByUrl
      this.router.navigateByUrl(route);
    } else if (route.includes("/")) {
      // Relative path with parameters - split into segments
      const segments = route.split("/");
      this.router.navigate(segments);
    } else {
      // Simple route without parameters
      this.router.navigate([route]);
    }
  }

  async back(): Promise<void> {
    let previousPages =
      (await this.localStorageService.getItem("previousPages")) || [];
    if (previousPages && previousPages.length != 0) {
      let prevPage = previousPages.pop();
      await this.localStorageService.setItem("previousPages", previousPages);
      await this.localStorageService.setItem("currentPage", prevPage);

      // Handle routes with parameters by splitting into segments
      if (prevPage.startsWith("/")) {
        // Absolute path - use navigateByUrl
        this.router.navigateByUrl(prevPage);
      } else if (prevPage.includes("/")) {
        // Relative path with parameters - split into segments
        const segments = prevPage.split("/");
        this.router.navigate(segments);
      } else {
        // Simple route without parameters
        this.router.navigate([prevPage]);
      }
    }
  }
}
